import classNames from 'classnames'

import Button from '../Button'

import * as styles from './Borderless.module.css'

function Borderless({ className, isActive, ...restProps }) {
  const buttonClassName = classNames(
    styles.borderless,
    { [styles.opened]: isActive },
    className
  )

  return (
    <Button
      {...restProps}
      isBorderless
      className={buttonClassName}
      iconClassName={styles.icon}
      isActive={isActive}
    />
  )
}

export default Borderless
